(function () {
  'use strict';

  function parseScheduleDate(value) {
    if (!value) return NaN;
    var normalized = value.trim();
    var dateMatch = normalized.match(/^(\d{4})-(\d{2})-(\d{2})[.\sT](\d{1,2}):(\d{2})$/);
    if (dateMatch) {
      return new Date(
        parseInt(dateMatch[1], 10),
        parseInt(dateMatch[2], 10) - 1,
        parseInt(dateMatch[3], 10),
        parseInt(dateMatch[4], 10),
        parseInt(dateMatch[5], 10),
        0
      ).getTime();
    }
    return new Date(normalized).getTime();
  }

  function getItemState(startTime, endTime) {
    var now = Date.now();
    if (!isNaN(endTime) && now >= endTime) return 'ended';
    if (!isNaN(startTime) && now < startTime) return 'upcoming';
    return 'active';
  }

  function hideItem(el) {
    el.hidden = true;
    el.setAttribute('aria-hidden', 'true');
    el.classList.add('is-schedule-ended');
  }

  function showItem(el) {
    el.hidden = false;
    el.removeAttribute('aria-hidden');
    el.classList.remove('is-schedule-upcoming', 'is-schedule-ended');
  }

  function hideContainer(container, wrapperEl) {
    var target = wrapperEl || container;
    if (!target) return;
    target.hidden = true;
    target.setAttribute('aria-hidden', 'true');
    target.classList.add('is-schedule-empty');
  }

  function showContainer(container, wrapperEl) {
    var target = wrapperEl || container;
    if (!target) return;
    target.hidden = false;
    target.removeAttribute('aria-hidden');
    target.classList.remove('is-schedule-empty');
  }

  function initScheduledItems(container, options) {
    options = options || {};
    var wrapperEl = options.wrapperEl || null;
    var onUpdate = options.onUpdate;
    var items = container.querySelectorAll('[data-schedule-item]');

    if (!items.length) return;

    function updateAll() {
      var activeCount = 0;
      var nextTickMs = Infinity;

      items.forEach(function (el) {
        var startTime = el.dataset.scheduleStart ? parseScheduleDate(el.dataset.scheduleStart) : NaN;
        var endTime = el.dataset.scheduleEnd ? parseScheduleDate(el.dataset.scheduleEnd) : NaN;
        var state = getItemState(startTime, endTime);

        if (state === 'ended') {
          hideItem(el);
        } else if (state === 'upcoming') {
          hideItem(el);
          el.classList.add('is-schedule-upcoming');
          if (!isNaN(startTime)) {
            nextTickMs = Math.min(nextTickMs, startTime - Date.now());
          }
        } else {
          showItem(el);
          activeCount++;
          if (!isNaN(endTime)) {
            nextTickMs = Math.min(nextTickMs, endTime - Date.now());
          }
        }
      });

      if (activeCount === 0) {
        hideContainer(container, wrapperEl);
      } else {
        showContainer(container, wrapperEl);
      }

      if (onUpdate) onUpdate(activeCount);

      if (nextTickMs !== Infinity && nextTickMs > 0) {
        setTimeout(updateAll, Math.min(nextTickMs + 100, 60000));
      } else if (activeCount > 0) {
        setTimeout(updateAll, 60000);
      }
    }

    updateAll();
  }

  window.ScheduleItems = {
    parseScheduleDate: parseScheduleDate,
    init: initScheduledItems
  };
})();
